import { mapCodeToMessageIplant } from "./errorsIplan";

export interface IPlanMsg {
  itemNo: string;
  firstCode: string;
  secondCode: string;
  message: string;
}

export interface SAPMsg {
  errorCode: string;
  soNo: string;
  errorMessage: string;
}

export const getSAPMessage = (sapOrderMessages: SAPMsg[]) => {
  let messageErr = "";
  if (sapOrderMessages) {
    sapOrderMessages.forEach(({ errorCode, soNo, errorMessage }) => {
      messageErr += `${soNo} - ${errorCode} - ${errorMessage} \n`;
    });
  }
  return messageErr;
};

export const getIPlanMessages = (iPlanMessages: IPlanMsg[]) => {
  let sapOrderErrors = "";
  iPlanMessages.forEach(item => {
    const messageOptional = item.message;
    const message = mapCodeToMessageIplant(
      item.firstCode,
      item.secondCode,
      messageOptional
    );
    sapOrderErrors += `${message} \n`;
  });
  return sapOrderErrors;
};
export const getIPlanMessagesCancelItem = (iPlanMessages: IPlanMsg[]) => {
  let sapOrderErrors = "";
  iPlanMessages.forEach(item => {
    const message = `${item.itemNo} ${item.firstCode || ""}${item.secondCode ||
      ""} - ${item.message}`;
    sapOrderErrors += `${message} \n`;
  });
  return sapOrderErrors;
};

export const getPlainTextFromEnum = (enumText: string) => {
  // Use for convert ABC_ABC to Abc Abc
  if (!enumText) {
    return enumText;
  }
  const arrEnumText = enumText.split("_");
  const arrEnumTextRemap = arrEnumText.map(textSplit => {
    const arrSplit = textSplit.split("");
    const arrSplitRemap = arrSplit.map((letter, index) =>
      index === 0 ? letter.toUpperCase() : letter.toLowerCase()
    );
    return arrSplitRemap.join("");
  });
  return arrEnumTextRemap.join(" ");
};
